/**
 * The first point at which the app entry module body can run. Static imports
 * have already evaluated, so this is not a direct measure of parse completion.
 */
export const APP_ENTRY_BODY_STARTED_TIMING = 'app_entry_body_started';

let appEntryBodyStartedAt: number | undefined;

/**
 * Captures the navigation-relative timestamp before Datadog RUM is available.
 */
export function markAppEntryBodyStarted(
  time: number = performance.now()
): void {
  appEntryBodyStartedAt ??= time;
}

/**
 * Returns the captured timestamp once so it can be attached to the initial
 * manually tracked RUM view after that view starts.
 */
export function takeAppEntryBodyStartedTiming(): number | undefined {
  const time = appEntryBodyStartedAt;
  appEntryBodyStartedAt = undefined;
  return time;
}
